import EmptyPlaceholder from '../../commons/EmptyPlaceholder';

const VariableEmpty = () => {
  return <EmptyPlaceholder placeholder="Aucunes variables créées" />;
};

export default VariableEmpty;
